import React, { useState, useEffect, useCallback } from 'react';
import Container from '@material-ui/core/Container';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import { Tooltip } from '@mui/material';
import { MenuItem, Select, FormControl, InputLabel } from '@mui/material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle'; // Ícone para "finalizar"
import IconButton from '@mui/material/IconButton';
import Snackbar from '@mui/material/Snackbar';
import MuiAlert from '@mui/material/Alert';
import AddIcon from '@mui/icons-material/Add';
import DoneIcon from '@mui/icons-material/Done';
import TextField from '@material-ui/core/TextField';
import RefreshIcon from '@mui/icons-material/Refresh';
import Cookies from 'js-cookie';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import AppBar from '@mui/material/AppBar';
import Box from '@material-ui/core/Box';
import { useHistory } from "react-router-dom";
import moment from 'moment';
import { useParams } from "react-router-dom";
import SwipeableViews from 'react-swipeable-views';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Checkbox from '@material-ui/core/Checkbox';
import Typography from '@material-ui/core/Typography';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Collapse from '@material-ui/core/Collapse';
import Paper from '@material-ui/core/Paper';
import Autocomplete from '@material-ui/lab/Autocomplete';
import Skeleton from '@material-ui/lab/Skeleton';
import { Card, CardContent } from '@mui/material';
import { Link } from 'react-router-dom';
import DoneAllIcon from '@mui/icons-material/DoneAll';
import CheckIcon from '@mui/icons-material/Check';
import { useDropzone } from 'react-dropzone';
import VisibilityIcon from '@mui/icons-material/Visibility';
import CancelIcon from '@mui/icons-material/Cancel';
import Divider from '@mui/material/Divider';

import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined'; // Ícone apropriado
import ComputerOutlinedIcon from '@mui/icons-material/ComputerOutlined';
import SearchOutlinedIcon from '@mui/icons-material/SearchOutlined';
import EngineeringOutlinedIcon from '@mui/icons-material/EngineeringOutlined';
import AssignmentOutlinedIcon from '@mui/icons-material/AssignmentOutlined';
import ChecklistOutlinedIcon from '@mui/icons-material/ChecklistOutlined';
import GroupsOutlinedIcon from '@mui/icons-material/GroupsOutlined';
import SwapHorizIcon from '@material-ui/icons/SwapHoriz';

import {
    DataGrid,  
    GridToolbarContainer,
    GridToolbarColumnsButton,
    GridToolbarFilterButton,
    GridToolbarExport,
    GridToolbarDensitySelector,
} from '@mui/x-data-grid';

import ButtonGroup from '@material-ui/core/ButtonGroup';



import { styled } from '@material-ui/styles';


import api from '../../../../../../services/api';
import NavegadorGestao from "../../../../../../components/NavBarGestao";
import CabecalhoInformacoes2 from "../../../../../../pages/painelAdmin/AreaGestao/ModuloAdministracao/OrdensDeServicos/CabecalhoInformacoes2.js";
import { makeStyles } from '@material-ui/core/styles';


import AtualizarProcedimentoExecucao from './atualizarProcedimentoExecucao'
import { Drawer, List, ListItemButton, ListItemText } from "@mui/material";
import miniatura_pdf from '../../../../../../assets/imgs/miniatura_pdf.png';
import office from '../../../../../../assets/imgs/office.png';

import ContentCopy from "@mui/icons-material/ContentCopy";


const useStyles = makeStyles((theme) => ({

    whiteUnderline: {
        '&:before': {
            borderBottom: '1px solid white',
        },
        '&:after': {
            borderBottom: '2px solid white',
        },
        '&:hover:not($disabled):before': {
            borderBottom: '1px solid white',
        },
    },
    cabecalho_azul: {
        backgroundColor: '#3f51b5',
        color: 'white',
        fontWeight: 'bold',
    },
    cabecalho_dark: {
        backgroundColor: '#2d2d2d !important',
        color: 'white !important',
        fontWeight: 'bold',
    },
}));


const ColorButtonRed = styled(Button)(({ theme }) => ({
    color: 'white',
    backgroundColor: 'red',
    borderColor: 'black',
    '&:hover': {
        backgroundColor: 'red',
        color: 'whit',
        borderColor: 'blue',
    },
}));


const ColorButtonGreen = styled(Button)(({ theme }) => ({
    color: 'white',
    backgroundColor: 'green',
    borderColor: 'black',
    '&:hover': {
        backgroundColor: 'green',
        color: 'blue',
        borderColor: 'blue',
    },
}));



const dropzoneStyles = (themeHelper) => ({
    border: `4px dashed ${themeHelper.border}`,
    borderRadius: '4px',
    padding: '2px',
    textAlign: 'center',
    cursor: 'pointer',
    margin: '2px 0',
});


export default function GerenciarEntradaEstoque() {

    const [darkMode, setDarkMode] = useState(Cookies.get('darkMode') === 'true');

    const classes = useStyles();


    const history = useHistory();


    const [armazenamentos, setArmazenamentos] = useState([]);



    const [itens, setItens] = useState([]);

    const [itensOriginais, setItensOriginais] = useState([]);


    const currencyFormatter = new Intl.NumberFormat('pt-BR', {
        style: 'currency',
        currency: 'BRL',
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
    });


    useEffect(() => {
        const handleDarkModeChange = () => {
            const isDark = Cookies.get('darkMode') === 'true';
            setDarkMode(isDark);
        };

        window.addEventListener('darkModeChanged', handleDarkModeChange);
        window.addEventListener('focus', handleDarkModeChange);

        // Inicializa estado
        const currentDarkMode = Cookies.get('darkMode') === 'true';
        setDarkMode(currentDarkMode);

        return () => {
            window.removeEventListener('darkModeChanged', handleDarkModeChange);
            window.removeEventListener('focus', handleDarkModeChange);
        };
    }, []);

    const themeHelper = {
        paper: darkMode ? '#121212' : '#ffffff',
        text: darkMode ? '#ffffff' : '#000000',
        border: darkMode ? '#ffffff' : '#000000',
    };

    const textFieldInputProps = darkMode ? {
        style: { color: 'white' },
        classes: { underline: classes.whiteUnderline },
    } : {};

    const textFieldInputLabelProps = darkMode ? {
        style: { color: 'white' },
    } : {};

    const textFieldSxOutlined = darkMode ? {
        '& .MuiOutlinedInput-root': {
            '& fieldset': { borderColor: 'white' },
            '&:hover fieldset': { borderColor: 'white' },
            '&.Mui-focused fieldset': { borderColor: 'white' },
            color: 'white',
        },
        '& .MuiInputLabel-root': { color: 'white' },
    } : {};

    const textFieldSxStandard = darkMode ? {
        '& .MuiInput-underline:before': { borderBottomColor: 'white' },
        '& .MuiInput-underline:after': { borderBottomColor: 'white' },
        '& .MuiInput-underline:hover:before': { borderBottomColor: 'white' },
        '& input': { color: 'white' },
        '& textarea': { color: 'white' },
        '& .MuiInputLabel-root': { color: 'white' },
    } : {};

    const [selectedProcedimentoIndex, setSelectedProcedimentoIndex] = useState(0); // seleciona o primeiro por padrão

    const [tabelaKey, setTabelaKey] = useState(0);

    // Função para limpar o prefixo
    const formatarNome = (nome) => {
        if (!nome) return "Procedimento";
        return nome.replace("Verificar Recebimento de Mercadoria - ", "");
    };

    const [value, setValue] = React.useState(0);

    async function listarInformacoes() {
        setLoading(true);

        try {
            const token = Cookies.get('token');
            const headers = { 'Authorization': 'Bearer ' + token };

            // 1) buscar entrada de estoque
            const resEntrada = await api.get(
                `v1/protected/almoxarifado/entradaestoque/listarentradaestoqueporid/${idEntradaEstoque}`,
                { headers }
            );
            setEntradaEstoque(resEntrada.data);
            setNumeroNf(resEntrada.data.numero_nf);
            setChaveNf(resEntrada.data.chave_nf);

            setNumeroNf2(resEntrada.data.numero_nf2);
            setChaveNf2(resEntrada.data.chave_nf2);

            setNumeroNf3(resEntrada.data.numero_nf3);
            setChaveNf3(resEntrada.data.chave_nf3);

            try {
                const resOrdem = await api.get(
                    `/v1/protected/ordemservico/listarporid/${resEntrada.data.ordem_servico.id_ordem_servico}`,
                    { headers }
                );
                setOrdemServico(resOrdem.data);

                // (separar estados diversos como antes)

                const sortedItensPreRequerimento = resOrdem.data.itens_pre_requerimento?.sort(
                    (a, b) => a.id_item_na_lista - b.id_item_na_lista
                );
                if (sortedItensPreRequerimento) {
                    setOrdemServico({ ...resOrdem.data, itens_pre_requerimento: sortedItensPreRequerimento });
                }
                setDescricao(resOrdem.data.descricao);
                setSolicitante(resOrdem.data.usuario_solicitante);
                setSolicitacaoSelecionada(resOrdem.data.solicitacao);
                setCategoria(resOrdem.data.categoria_ordem);
                setPropostaSelecionada(resOrdem.data.proposta);
                setProjetoSelecionado(resOrdem.data.projeto);
                setColaboradorSelecionado(resOrdem.data.colaborador);
                setPed(resOrdem.data.ped);
                setAnalista(resOrdem.data.analista);
                setSolicitantesSelecionados(resOrdem.data.solicitantes);
                setInstalacaoSelecionada(resOrdem.data.instalacao);

            } catch (e) { /* ignore */ }


            // 3) itens selecionados da entrada (como você já fazia)
            const itensSelecionados = resEntrada.data.pre_cotacao.itens_pre_cotacao
                .filter(item => item.selecionado === 1)
                .sort((a, b) => {
                    const descA = a?.insumo?.descricao?.toLowerCase() || '';
                    const descB = b?.insumo?.descricao?.toLowerCase() || '';
                    return descA.localeCompare(descB);
                });

            // 4) Para cada item, buscar registros de estoque e agregar quantidade
            // Paralelizamos com Promise.all, mas tratamos falhas individualmente
            const promessas = itensSelecionados.map(item => {
                const idItem = item.id_item_ordem_compra;
                return api.get(`v1/protected/almoxarifado/estoque/listarporitemordemcompraeprecotacao/${idItem}/${resEntrada.data.pre_cotacao.id_pre_cotacao}`, { headers })
                    .then(res => ({ item, estoque: res.data }))
                    .catch(err => {
                        console.error(`Erro ao buscar estoque para item ${idItem}`, err);
                        return ({ item, estoque: [] });
                    });
            });

            const resultados = await Promise.all(promessas);

            // 5) montar lista agregada: 1 linha por item, quantidade_estoque = soma
            const itensAgregados = resultados.map(({ item, estoque }, index) => {
                // calcular quantidade em estoque:
                // se os registros de estoque tiverem field 'quantidade_estoque' (ou 'quantidade'), some essas quantidades.
                // senão, use estoque.length (uma linha por unidade).
                let quantidadeEmEstoque = 0;
                if (Array.isArray(estoque) && estoque.length > 0) {
                    // se existir propriedade quantidade_estoque/quantidade em cada registro, some:
                    const existeCampoQuantidade = estoque.some(e => e.quantidade_estoque != null || e.quantidade != null);
                    if (existeCampoQuantidade) {
                        quantidadeEmEstoque = estoque.reduce((acc, e) => acc + (Number(e.quantidade_estoque ?? e.quantidade ?? 0)), 0);
                    } else {
                        // fallback: contar registros
                        quantidadeEmEstoque = estoque.length;
                    }
                } else {
                    quantidadeEmEstoque = 0;
                }

                // decidir armazenamento padrão: se todos os registros tiverem o mesmo armazenamento, use ele.
                // senão, mantenha null (o usuário escolherá).
                let armazenamentoEscolhido = null;
                if (Array.isArray(estoque) && estoque.length > 0) {
                    const armazenamentosEncontrados = estoque
                        .map(e => e.armazenamento || null)
                        .filter(a => a != null);

                    if (armazenamentosEncontrados.length > 0) {
                        // checar se todos id_armazenamento são iguais
                        const todosIguais = armazenamentosEncontrados.every(a => a.id_armazenamento === armazenamentosEncontrados[0].id_armazenamento);
                        armazenamentoEscolhido = todosIguais ? armazenamentosEncontrados[0] : null;
                    }
                }

                // pegar do estoque se existir
                const codigoBarrasEstoque = estoque.length > 0 ? estoque[0].codigo_barras : (item.codigo_barras || "");
                const descricaoArmazenamentoEstoque = estoque.length > 0 ? estoque[0].descricao_armazenamento : (item.descricao_armazenamento || "");


                return {
                    id: item.id_item_ordem_compra || `novo-${index + 1}`,
                    id_item_ordem_compra: item.id_item_ordem_compra,
                    cotacao: item,
                    insumo: item.insumo,
                    quantidade: Number(item.quantidade || 0),

                    // quantidade atual e a original (vinda do banco)
                    quantidade_estoque: Number(quantidadeEmEstoque),
                    quantidade_estoque_original: Number(quantidadeEmEstoque), // 👈 usado no DataGrid


                    codigo_barras: codigoBarrasEstoque,
                    descricao_armazenamento: descricaoArmazenamentoEstoque,
                    numero_serie: item.numero_serie || "",
                    extras: item.extras || "",
                    id_armazenamento: armazenamentoEscolhido ? Number(armazenamentoEscolhido.id_armazenamento) : 0,
                    armazenamento: armazenamentoEscolhido || null,
                    id_insumo: item.insumo.id_insumo,
                    id_ordem_compra: resEntrada.data.ordem_compra.id_ordem_compra,
                    id_pre_cotacao: resEntrada.data.pre_cotacao.id_pre_cotacao,
                    registros_estoque: estoque
                };
            });


            setItensOriginais(itensAgregados);
            // 6) setar estado que o DataGrid consome (no seu código recente você usa setItens)
            setItens(itensAgregados);

            // 7) carregar armazenamentos
            const resArmazenamentos = await api.get('v1/protected/almoxarifado/armazenamento/listar', { headers });
            setArmazenamentos(resArmazenamentos.data);

            setLoading(false);
        } catch (err) {
            console.error("Erro ao listar as informações: ", err);
            setLoading(false);
        }
    }



    useEffect(() => {
        listarInformacoes();
    }, []);




    const columnsDataGrid = React.useMemo(() => [
        {
            headerName: 'ID',
            field: 'id_item_ordem_compra',
            width: 50,
            headerClassName: darkMode ? classes.cabecalho_dark : classes.cabecalho_azul,
        },
        {
            headerName: 'Insumo',
            field: 'cotacao',
            width: 300,
            headerClassName: darkMode ? classes.cabecalho_dark : classes.cabecalho_azul,
            renderCell: (cellValues) => {
                const insumo = cellValues.row.insumo;
                const cotacao = cellValues.row.cotacao;
                let textoComQuebraDeLinha = "Descrição Principal: " + insumo.descricao + "\n\n";

                if (insumo.variacoes && insumo.variacoes.length > 0) {
                    textoComQuebraDeLinha += insumo.variacoes
                        .filter(v => v.id_fornecedor !== cotacao.fornecedor.id_fornecedor)
                        .map((v, i) =>
                            `Fornecedor: ${v.nome_amigavel_fornecedor} Variação: ${v.descricao}${i !== insumo.variacoes.length - 1 ? '\n' : ''}`
                        )
                        .join('');
                }

                return (
                    <Tooltip
                        title={
                            <div style={{ backgroundColor: 'white', color: 'black', border: '2px solid black', padding: 8 }}>
                                {textoComQuebraDeLinha.split('\n').map((line, index) => (
                                    <React.Fragment key={index}>
                                        {line}
                                        <br />
                                    </React.Fragment>
                                ))}
                            </div>
                        }
                        placement="top"
                        arrow
                    >
                        <span>{returnDescricaoInsumo(insumo)}</span>
                    </Tooltip>
                );
            },
        },
        {
            headerName: 'Qtd Da O.C',
            field: 'quantidade',
            width: 140,
            headerClassName: darkMode ? classes.cabecalho_dark : classes.cabecalho_azul,
            renderCell: (cellValues) => {
                const quantidade = cellValues.row.quantidade;
                return (
                    <TextField
                        defaultValue={quantidade}
                        InputProps={{
                            style: { color: darkMode ? 'white' : 'black' },
                            classes: darkMode ? { underline: classes.whiteUnderline } : {},
                        }}
                        InputLabelProps={textFieldInputLabelProps}
                        sx={textFieldSxOutlined}
                        variant="outlined"
                    />
                );
            },
        },
        {
            headerName: 'Qtd para Estoque',
            field: 'quantidade_estoque',
            width: 140,
            headerClassName: darkMode ? classes.cabecalho_dark : classes.cabecalho_azul,
            renderCell: (cellValues) => {
                const quantidadeOC = Number(cellValues.row.quantidade || 0);
                const quantidadeEstoque = Number(cellValues.row.quantidade_estoque || 0);
                const quantidadeOriginal = Number(cellValues.row.quantidade_estoque_original || 0);
                const desabilitado = quantidadeOriginal === quantidadeOC;

                const handleChange = (event) => {
                    let novoValor = Number(event.target.value);
                    if (novoValor < quantidadeEstoque) novoValor = quantidadeEstoque;
                    if (novoValor > quantidadeOC) novoValor = quantidadeOC;
                    setItens(prev =>
                        prev.map(item =>
                            item.id === cellValues.row.id
                                ? { ...item, quantidade_estoque: novoValor }
                                : item
                        )
                    );
                };

                return (
                    <TextField
                        type="number"
                        value={quantidadeEstoque}
                        onChange={handleChange}
                        variant="outlined"
                        size="small"
                        disabled={desabilitado}
                        inputProps={{
                            min: quantidadeEstoque,
                            max: quantidadeOC,
                        }}
                        InputProps={{ style: darkMode ? { color: 'white' } : {} }}
                        InputLabelProps={textFieldInputLabelProps}
                        sx={textFieldSxOutlined}
                    />
                );
            },
        },
        {
            headerName: 'Cod Barras',
            field: 'codigo_barras',
            width: 80,
            headerClassName: darkMode ? classes.cabecalho_dark : classes.cabecalho_azul,
            renderCell: (cellValues) => {
                const codigoAtual = cellValues.row.codigo_barras;
                const handleChange = (event) => {
                    const novoValor = event.target.value;
                    setItens(prev =>
                        prev.map(item =>
                            item.id === cellValues.row.id
                                ? { ...item, codigo_barras: novoValor }
                                : item
                        )
                    );
                };

                return (
                    <TextField
                        value={codigoAtual}
                        onChange={handleChange}
                        variant="outlined"
                        size="small"
                        onKeyDown={(e) => e.stopPropagation()}
                        InputProps={{ style: darkMode ? { color: 'white' } : {} }}
                        InputLabelProps={textFieldInputLabelProps}
                        sx={textFieldSxOutlined}
                    />
                );
            },
        },
        {
            field: "armazenamento",
            headerName: "Armazenamento",
            width: 150,
            headerClassName: darkMode ? classes.cabecalho_dark : classes.cabecalho_azul,
            editable: false,
            renderCell: (params) => {
                const selectedValue = Number(params.row.id_armazenamento || 0) || "";
                const handleReplicar = () => {
                    const idSelecionado = Number(params.row.id_armazenamento);
                    if (!idSelecionado) return;
                    const indexAtual = itens.findIndex(i => i.id === params.row.id);
                    setItens(prev =>
                        prev.map((row, idx) =>
                            idx > indexAtual ? { ...row, id_armazenamento: idSelecionado, armazenamento: null } : row
                        )
                    );
                };

                return (
                    <div style={{ display: "flex", alignItems: "center", width: "100%", position: "relative" }}>
                        <Select
                            value={selectedValue}
                            onChange={(e) => {
                                const idSelecionado = Number(e.target.value);
                                setItens(prev =>
                                    prev.map(row =>
                                        row.id === params.row.id
                                            ? { ...row, id_armazenamento: idSelecionado, armazenamento: null }
                                            : row
                                    )
                                );
                            }}
                            displayEmpty
                            fullWidth
                            style={darkMode ? { color: 'white' } : {}}
                        >
                            <MenuItem value="">
                                <em>Selecione</em>
                            </MenuItem>
                            {armazenamentos.map((armazenamento) => (
                                <MenuItem key={armazenamento.id_armazenamento} value={Number(armazenamento.id_armazenamento)}>
                                    {resumoArmazenamento(armazenamento)}
                                </MenuItem>
                            ))}
                        </Select>
                        {selectedValue > 0 && (
                            <IconButton
                                onClick={handleReplicar}
                                size="small"
                                color="primary"
                                style={{
                                    position: "absolute",
                                    right: 4,
                                    top: "50%",
                                    transform: "translateY(-50%)",
                                    zIndex: 1000,
                                }}
                            >
                                <ContentCopy fontSize="small" style={darkMode ? { color: 'white' } : {}} />
                            </IconButton>
                        )}
                    </div>
                );
            }
        },
        {
            headerName: 'Descrição Armaz',
            field: 'descricao_armazenamento',
            width: 300,
            headerClassName: darkMode ? classes.cabecalho_dark : classes.cabecalho_azul,
            renderCell: (cellValues) => {
                const descricaoAtual = cellValues.row.descricao_armazenamento;
                const handleChange = (event) => {
                    const novoValor = event.target.value;
                    setItens(prev =>
                        prev.map(item =>
                            item.id === cellValues.row.id
                                ? { ...item, descricao_armazenamento: novoValor }
                                : item
                        )
                    );
                };

                return (
                    <TextField
                        value={descricaoAtual}
                        onChange={handleChange}
                        variant="standard"
                        size="small"
                        onKeyDown={(e) => e.stopPropagation()}
                        InputProps={textFieldInputProps}
                        InputLabelProps={textFieldInputLabelProps}
                        sx={textFieldSxStandard}
                    />
                );
            },
        }
    ], [darkMode, itens, armazenamentos, classes.whiteUnderline, textFieldInputProps, textFieldInputLabelProps, textFieldSxOutlined, textFieldSxStandard]);

    const handleChangeTab = (event, newValue) => {
        setValue(newValue);

    }

    const [solicitante, setSolicitante] = useState(null);
    const [solicitantesSelecionados, setSolicitantesSelecionados] = useState([]);

    const [analista, setAnalista] = useState(null);

    const [instalacaoSelecionada, setInstalacaoSelecionada] = useState(null);
    const [descricao, setDescricao] = useState('');
    const [solicitacaoSelecionada, setSolicitacaoSelecionada] = useState(null);





    const handleChange = (event, newValue) => {

        setValue(newValue);

    }


    const handleChangeIndex = (index) => {

        setValue(index);
    };

    const [openAtualizando, setOpenAtualizando] = useState(false);
    const [chaveNf, setChaveNf] = useState("");
    const [numeroNf, setNumeroNf] = useState("");

    const [chaveNf2, setChaveNf2] = useState("");
    const [numeroNf2, setNumeroNf2] = useState("");


    const [chaveNf3, setChaveNf3] = useState("");
    const [numeroNf3, setNumeroNf3] = useState("");


    const { idEntradaEstoque } = useParams();
    const [larguraOriginal, setLarguraOriginal] = useState(0);
    const [limiar, setLimiar] = useState(900);

    const [categoria, setCategoria] = useState(0);

    const [ordemServico, setOrdemServico] = useState();


    const [botaoClicado, setBotaoClicado] = useState(false);
    const [loading, setLoading] = useState(true);
    const [entradaEstoque, setEntradaEstoque] = useState([]);
    const [projetoSelecionado, setProjetoSelecionado] = useState(null);
    const [propostaSelecionada, setPropostaSelecionada] = useState(null);
    const [ped, setPed] = useState(null);
    const [colaboradorSelecionado, setColaboradorSelecionado] = useState(null);




    const onDropArquivo1 = useCallback(async (acceptedFiles) => {
        // Valida o tipo de arquivo
        // Valida o tipo de arquivo
        if (!acceptedFiles[0].type.includes('application/pdf') && !acceptedFiles[0].type.includes('application/vnd.openxmlformats-officedocument')) {
            alert('Apenas arquivos PDF ou do Office são permitidos.');
            return;
        }

        // Processa o arquivo PNG
        setOpenAtualizando(true);
        try {
            const formData = new FormData();
            formData.append('arquivos', acceptedFiles[0]);
            formData.append('extensao', acceptedFiles[0].name.split('.').pop());

            const response = await api.post('/v1/protected/almoxarifado/estoque/anexararquivoentradaestoque/' + idEntradaEstoque, formData);

            const cadastro_salvo = response.data;
            if (cadastro_salvo) {

                setEntradaEstoque(response.data);

            } else {
                // Lógica a ser executada caso ocorra algum erro durante o salvamento
            }
            setOpenAtualizando(false);
        } catch (_err) {
            console.log("erro ao cadastrar: " + _err);
            alert("Erro de Conexão, tente novamente mais tarde");
            setOpenAtualizando(false);
        }
    }, []);


    const onDropArquivo2 = useCallback(async (acceptedFiles) => {
        // Valida o tipo de arquivo
        // Valida o tipo de arquivo
        if (!acceptedFiles[0].type.includes('application/pdf') && !acceptedFiles[0].type.includes('application/vnd.openxmlformats-officedocument')) {
            alert('Apenas arquivos PDF ou do Office são permitidos.');
            return;
        }

        // Processa o arquivo PNG
        setOpenAtualizando(true);
        try {
            const formData = new FormData();
            formData.append('arquivos', acceptedFiles[0]);
            formData.append('extensao', acceptedFiles[0].name.split('.').pop());

            const response = await api.post('/v1/protected/almoxarifado/estoque/anexararquivo2entradaestoque/' + idEntradaEstoque, formData);

            const cadastro_salvo = response.data;
            if (cadastro_salvo) {

                setEntradaEstoque(response.data);

            } else {
                // Lógica a ser executada caso ocorra algum erro durante o salvamento
            }
            setOpenAtualizando(false);
        } catch (_err) {
            console.log("erro ao cadastrar: " + _err);
            alert("Erro de Conexão, tente novamente mais tarde");
            setOpenAtualizando(false);
        }
    }, []);

    const onDropArquivo3 = useCallback(async (acceptedFiles) => {
        // Valida o tipo de arquivo
        // Valida o tipo de arquivo
        if (!acceptedFiles[0].type.includes('application/pdf') && !acceptedFiles[0].type.includes('application/vnd.openxmlformats-officedocument')) {
            alert('Apenas arquivos PDF ou do Office são permitidos.');
            return;
        }

        // Processa o arquivo PNG
        setOpenAtualizando(true);
        try {
            const formData = new FormData();
            formData.append('arquivos', acceptedFiles[0]);
            formData.append('extensao', acceptedFiles[0].name.split('.').pop());

            const response = await api.post('/v1/protected/almoxarifado/estoque/anexararquivo3entradaestoque/' + idEntradaEstoque, formData);

            const cadastro_salvo = response.data;
            if (cadastro_salvo) {

                setEntradaEstoque(response.data);

            } else {
                // Lógica a ser executada caso ocorra algum erro durante o salvamento
            }
            setOpenAtualizando(false);
        } catch (_err) {
            console.log("erro ao cadastrar: " + _err);
            alert("Erro de Conexão, tente novamente mais tarde");
            setOpenAtualizando(false);
        }
    }, []);



    const { getRootProps: getRootArquivoProps1, getInputProps: getInputArquivoProps1 } = useDropzone({
        onDrop: onDropArquivo1,
        multiple: false, // Apenas um arquivo pode ser selecionado
        //accept: '.pdf', // Restringe a aceitação apenas para arquivos .pdf

    });


    const { getRootProps: getRootArquivoProps2, getInputProps: getInputArquivoProps2 } = useDropzone({
        onDrop: onDropArquivo2,
        multiple: false, // Apenas um arquivo pode ser selecionado
        //accept: '.pdf', // Restringe a aceitação apenas para arquivos .pdf

    });


    const { getRootProps: getRootArquivoProps3, getInputProps: getInputArquivoProps3 } = useDropzone({
        onDrop: onDropArquivo3,
        multiple: false, // Apenas um arquivo pode ser selecionado
        //accept: '.pdf', // Restringe a aceitação apenas para arquivos .pdf

    });




    async function atualizar() {



        setOpenAtualizando(true);

        try {

            const cadastro = {
                numero_nf: numeroNf,
                chave_nf: chaveNf,
                numero_nf2: numeroNf2,
                chave_nf2: chaveNf2,
                numero_nf3: numeroNf3,
                chave_nf3: chaveNf3,
            }

            const headers = {
                'Authorization': 'Bearer ' + Cookies.get("token")
            }

            const response = await api.put('/v1/protected/almoxarifado/estoque/atualizarentradaestoque/' + idEntradaEstoque, cadastro,
                { headers: headers });

            const cadastro_salvo = response.data;

            if (cadastro_salvo) {
                setOpenAtualizando(true);
                setEntradaEstoque(cadastro_salvo);
                setNumeroNf(cadastro_salvo.numero_nf);
                setChaveNf(cadastro_salvo.chave_nf);
            } else {
                alert("Erro de Conexão, tente novamente mais tarde");
            }


        } catch (_err) {
            console.log("erro ao cadastrar: " + _err);
            alert("Erro de Conexão, tente novamente mais tarde");

        }
        setOpenAtualizando(false);


    }








    function checkDimenssoes() {
        var largura = window.innerWidth
            || document.documentElement.clientWidth
            || document.body.clientWidth;

        setLarguraOriginal(largura);


    }

    window.addEventListener('resize', function (event) {
        checkDimenssoes();
    });



    useEffect(() => {

        //alert("Regras: " + regra);

        checkDimenssoes();

    }, []);


    function returnDescricaoInsumo(insumo) {
        let preCotacao = null;
        for (const variacao of insumo.variacoes) {
            if (variacao.id_fornecedor === preCotacao.fornecedor.id_fornecedor) {
                // Se encontrar uma correspondência, retorna a descrição dessa variação com "Variação" em negrito
                return <span><strong>Variação:</strong> {variacao.descricao}</span>;
            }
        }

        // Se não houver correspondência, retorna a descrição principal do insumo
        return insumo.descricao;
    }




    function returnDescricaoUnidade(unidade) {

        console.log("unidade: " + unidade);

        var nome = unidade.nome_fantasia;

        var endereco = unidade.logradouro + ", nº " + unidade.numero + ", " + unidade.bairro + ", " + unidade.cidade + " " + unidade.estado + " CEP: " + unidade.cep;


        var texto = nome + " | " + unidade.cnpj;
        return texto;
    }


    function returnDescricaoArmazenamento(armazenamento) {
        try {
            if (!armazenamento || typeof armazenamento !== "object") {
                return "Armazenamento não disponível";
            }



            const {
                descricao = "—",
                sala = "—",
                corredor = "—",
                bloco = "—",
                gondola = "—",
                prateleira = "—",
            } = armazenamento;

            return (
                returnDescricaoUnidade(armazenamento.unidade) + "\n" +
                "Descrição: " + descricao
            );
        } catch (err) {
            console.error("Erro ao gerar descrição do armazenamento:", err);
            return "Erro ao processar dados de armazenamento";
        }
    }

    function resumoArmazenamento(armazenamento) {
        const textoCompleto = returnDescricaoArmazenamento(armazenamento);
        // Retorna até 30 caracteres + "..." se necessário
        return textoCompleto;
        //return textoCompleto.length > 30 ? textoCompleto.substring(0, 30) + "..." : textoCompleto;
    }




    const salvar = () => {
        // Verifica se o botão já foi clicado
        if (!botaoClicado) {
            // Executa a lógica do clique aqui
            console.log('Botão clicado!');

            // Atualiza o estado para indicar que o botão foi clicado
            setBotaoClicado(true);
            funcaoSalvar();
        }
    };


    async function funcaoSalvar() {
        try {
            // 1️⃣ Itens que tiveram aumento no estoque
            const itensAumentados = itens.filter(item => {
                const qtdEstoqueAtual = Number(item.quantidade_estoque) || 0;
                const qtdEstoqueAnterior = Number(item.quantidade_estoque_original) || 0;
                return qtdEstoqueAtual > qtdEstoqueAnterior;
            });

            // 2️⃣ Se nenhum foi alterado, aborta
            if (itensAumentados.length === 0) {
                alert("Nenhum item novo para adicionar ao estoque.");
                setBotaoClicado(false);
                return;
            }

            // 3️⃣ Verifica se todos os itens têm armazenamento selecionado
            const itemSemArmazenamento = itensAumentados.find(item => !item.id_armazenamento || item.id_armazenamento <= 0);
            if (itemSemArmazenamento) {
                alert("Selecione o Local de Armazenamento para todos os itens antes de salvar.");
                setBotaoClicado(false);
                return;
            }

            // 4️⃣ Monta mensagem de confirmação (somente texto)
            const mensagem =
                "Deseja prosseguir com a adição dos seguintes itens ao estoque?\n\n" +
                itensAumentados.map(item => {
                    const qtdAdicionando =
                        Number(item.quantidade_estoque) - Number(item.quantidade_estoque_original);
                    return `${item.insumo?.descricao || "Item sem nome"} — adicionando ${qtdAdicionando}`;
                }).join("\n");

            const shouldProceed = window.confirm(mensagem);
            if (!shouldProceed) {
                setBotaoClicado(false);
                return;
            }

            // 5️⃣ Monta payload real para enviar
            const payload = {
                ...entradaEstoque,
                itens_salvar: itensAumentados.map(item => ({
                    id_item_ordem_compra: item.id_item_ordem_compra,
                    quantidade_estoque: Number(item.quantidade_estoque),
                    id_armazenamento: Number(item.id_armazenamento),
                    codigo_barras: item.codigo_barras || "",
                    numero_serie: item.numero_serie || "",
                    extras: item.extras || "",
                    id_insumo: item.id_insumo,
                    id_ordem_compra: item.id_ordem_compra,
                    id_pre_cotacao: item.id_pre_cotacao,
                    descricao_armazenamento: item.descricao_armazenamento
                }))
            };

            // 6️⃣ Chamada da API
            const headers = { Authorization: "Bearer " + Cookies.get("token") };

            const response = await api.put(
                `/v1/protected/almoxarifado/estoque/salvaritensentradaestoque/${idEntradaEstoque}/${Cookies.get("id_usuario")}`,
                payload,
                { headers }
            );

            // 7️⃣ Confirmação
            if (response.data) {
                alert("✅ Itens adicionados ao estoque com sucesso!");
                listarInformacoes();
                setBotaoClicado(false);
            } else {
                alert("❌ Erro de conexão, tente novamente mais tarde.");
            }

        } catch (err) {
            console.error("Erro ao cadastrar:", err);
            setBotaoClicado(false);
            alert("Erro de conexão, tente novamente mais tarde");
        }
    }



    function CustomToolbar() {
        return (
            <GridToolbarContainer>
                <GridToolbarColumnsButton />
                <GridToolbarFilterButton />
                <GridToolbarDensitySelector />
                <GridToolbarExport />
            </GridToolbarContainer>
        );
    }


    const handleCellClick = (param, event) => {
        event.stopPropagation();
    };

    const handleRowClick = (param, event) => {
        event.stopPropagation();
    };



    const handleCellClick2 = (param, event) => {
        event.stopPropagation();
    };

    const handleRowClick2 = (param, event) => {
        event.stopPropagation();
    };

    return (
        <div style={{ backgroundColor: darkMode ? '#121212' : 'white', minHeight: '100vh', color: darkMode ? '#fff' : 'inherit' }}>
            <NavegadorGestao
                Almoxarifado={true}
                OpEntrada={true}
                corFundo={darkMode ? '#1e1e1e' : 'white'} travado={true} corTexto={darkMode ? '#fff' : 'black'}
            />
            <Grid
                container
                direction="row"
                justifyContent="flex-start"
                align="flex-start"
                item xs={12}
                style={{ width: '100%', margin: 0, padding: 0 }}
            >



                <a href="/gestao/operacional/almoxarifado/entradaestoque/listar" style={{ fontSize: 14, paddingTop: 5, paddingBottom: 5, color: darkMode ? '#90caf9' : 'black', marginRight: '5px' }}>{"< Operações de Entrada de Estoque - "}</a>



                <a href={"/gestao/operacional/almoxarifado/entradaestoque/gerenciarentradaestoque/" + idEntradaEstoque} style={{ fontSize: 14, color: darkMode ? '#90caf9' : 'black', paddingTop: 5, paddingBottom: 5, marginRight: '5px' }}>{"Entrada de Estoque Nº " + idEntradaEstoque}</a>



            </Grid>


            <Container style={{ paddingTop: 5 }} >
                {loading ?
                    <Skeleton animation={"wave"} width={'100%'} style={{ backgroundColor: '#48D1CC' }}>
                    </Skeleton>
                    :
                    <React.Fragment >
                        <Grid container spacing={2}
                            alignItems="center"
                            justifyContent="center"
                        >



                            <Grid
                                item xs={12}
                                container
                                direction="row"
                                alignItems="center"
                                justifyContent={"center"}
                            >


                                <Box style={{ backgroundColor: darkMode ? '#1e1e1e' : 'white', width: '100%', alignItems: 'center', }}>
                                    <AppBar position="static" style={{ backgroundColor: darkMode ? '#1a1a1a' : '#3f51b5' }}>

                                        <Tabs
                                            value={value}
                                            onChange={handleChangeTab}
                                            indicatorColor="secondary"
                                            textColor="inherit"
                                            variant="scrollable"
                                            scrollButtons="auto"
                                            aria-label="scrollable auto tabs example"


                                        >
                                            <Tab label="Informações Iniciais" style={{ backgroundColor: darkMode ? '#1C1C1C' : '#303f9f', color: 'white' }} />
                                            <Tab label="Execução" style={{ backgroundColor: 'green', color: 'white' }} />

                                        </Tabs>
                                    </AppBar>

                                </Box>
                            </Grid>



                            <Grid
                                style={{ paddingTop: 1 }}
                                container
                                direction="row"
                                item xs={12}
                                alignItems="center"
                                justifyContent="center"
                                spacing={2}
                            >


                                <SwipeableViews
                                    index={value}
                                    onChangeIndex={handleChangeIndex}
                                    style={{ backgroundColor: darkMode ? '#121212' : 'white', width: '100%', alignItems: 'center', }}
                                >

                                    <Grid
                                        value={value} index={0}
                                        style={{ paddingTop: 1 }}
                                        container
                                        direction="row"
                                        item xs={12}
                                        alignItems="center"
                                        justifyContent="center"
                                        spacing={2}
                                    >




                                        <CabecalhoInformacoes2
                                            ordemServico={ordemServico}
                                            instalacaoSelecionada={instalacaoSelecionada}
                                            projetoSelecionado={projetoSelecionado}
                                            propostaSelecionada={propostaSelecionada}
                                            solicitacaoSelecionada={solicitacaoSelecionada}
                                            solicitantesSelecionados={solicitantesSelecionados}
                                            solicitante={solicitante}
                                            analista={analista}
                                            ped={ped}
                                            ordemCompra={entradaEstoque.ordem_compra}
                                            compra={entradaEstoque.pre_cotacao}
                                            entradaEstoque={entradaEstoque}
                                        />

                                    </Grid>

                                    <Grid
                                        value={value} index={1}
                                        style={{ paddingTop: 20 }}
                                        container
                                        direction="row"
                                        item xs={12}
                                        alignItems="center"

                                        spacing={1}
                                    >




                                        <Grid
                                            item xs={4}
                                            container
                                            direction="row"
                                            alignItems="flex-start" // 👈 importante
                                        >
                                            <Grid
                                                item xs={9}
                                                container
                                                direction="column"
                                                alignItems="center" // 👈 importante
                                            >
                                                <Grid container item xs={12} >
                                                    <TextField
                                                        variant="standard"
                                                        name="numeroNf"
                                                        label="Número da NF"
                                                        required
                                                        id="numeroNf"
                                                        value={numeroNf}
                                                        onChange={(e) => setNumeroNf(e.target.value)}
                                                        fullWidth
                                                        multiline
                                                        minRows={1}
                                                        InputProps={textFieldInputProps}
                                                        InputLabelProps={textFieldInputLabelProps}
                                                        sx={textFieldSxStandard}
                                                    />
                                                </Grid>
                                                <Grid container item xs={12} >
                                                    <TextField
                                                        variant="standard"
                                                        name="chaveNf"
                                                        label="chaveNf"
                                                        required
                                                        id="chaveNf"
                                                        value={chaveNf}
                                                        onChange={(e) => setChaveNf(e.target.value)}
                                                        fullWidth
                                                        multiline
                                                        minRows={1}
                                                        InputProps={textFieldInputProps}
                                                        InputLabelProps={textFieldInputLabelProps}
                                                        sx={textFieldSxStandard}
                                                    />
                                                </Grid>
                                            </Grid>

                                            <Grid

                                                direction="row"
                                                justifyContent="center"
                                                align="cemter"
                                                item xs={1}
                                                container

                                            >

                                                {entradaEstoque.caminho_nf ? (
                                                    <div>
                                                        <div
                                                            onClick={() => {
                                                                const link = entradaEstoque.caminho_nf.replaceAll(
                                                                    "/home/wwgrup/entradaestoque/",
                                                                    "https://gruporosinetos.com/entradaestoquemidias/"
                                                                );
                                                                window.open(link, "_blank", "noopener,noreferrer");
                                                            }}
                                                            style={{ cursor: 'pointer', display: 'flex', justifyContent: 'center', margin: 0, width: '50px', height: '50px' }}
                                                        >
                                                            {/* Verifica a extensão do arquivo e exibe a miniatura ou o ícone correspondente */}
                                                            {entradaEstoque.caminho_nf.toLowerCase().endsWith('.pdf') ? (
                                                                <img alt={'miniatura_pdf'} style={{ textAlign: 'center' }} src={miniatura_pdf} />
                                                            ) : (
                                                                <img alt={'office'} style={{ textAlign: 'center' }} src={office} />
                                                            )}
                                                            <Typography align="center" variant="h7">
                                                                Nota Fiscal
                                                            </Typography>
                                                        </div>
                                                        <SwapHorizIcon {...getRootArquivoProps1()} />
                                                    </div>
                                                ) : (
                                                    <div {...getRootArquivoProps1()} style={dropzoneStyles(themeHelper)}>
                                                        <input {...getInputArquivoProps1()} />
                                                        <Typography align="center" variant="h7">
                                                            Anexo
                                                        </Typography>
                                                    </div>
                                                )}

                                            </Grid>
                                        </Grid>

                                        <Grid
                                            item xs={4}
                                            container
                                            direction="row"
                                            alignItems="flex-start" // 👈 importante
                                        >
                                            <Grid
                                                item xs={9}
                                                container
                                                direction="column"
                                                alignItems="center" // 👈 importante
                                                style={{ margin: 1 }}
                                                spacing={1}
                                            >
                                                <Grid container item xs={12} style={{ padding: 1 }}>
                                                    <TextField
                                                        variant="standard"
                                                        name="numeroNf2"
                                                        label="Número da NF"
                                                        required
                                                        id="numeroNf2"
                                                        value={numeroNf2}
                                                        onChange={(e) => setNumeroNf2(e.target.value)}
                                                        fullWidth
                                                        multiline
                                                        minRows={1}
                                                        InputProps={textFieldInputProps}
                                                        InputLabelProps={textFieldInputLabelProps}
                                                        sx={textFieldSxStandard}
                                                    />
                                                </Grid>
                                                <Grid container item xs={12} style={{ padding: 1 }}>
                                                    <TextField
                                                        variant="standard"
                                                        name="chaveNf2"
                                                        label="chaveNf2"
                                                        required
                                                        id="chaveNf2"
                                                        value={chaveNf2}
                                                        onChange={(e) => setChaveNf2(e.target.value)}
                                                        fullWidth
                                                        multiline
                                                        minRows={1}
                                                        InputProps={textFieldInputProps}
                                                        InputLabelProps={textFieldInputLabelProps}
                                                        sx={textFieldSxStandard}
                                                    />
                                                </Grid>
                                            </Grid>

                                            <Grid

                                                direction="row"
                                                justifyContent="center"
                                                align="cemter"
                                                item xs={1}
                                                container
                                                style={{ marginTop: 1 }}
                                            >

                                                {entradaEstoque.caminho_nf2 ? (
                                                    <div>
                                                        <div
                                                            onClick={() => {
                                                                const link = entradaEstoque.caminho_nf2.replaceAll(
                                                                    "/home/wwgrup/entradaestoque/",
                                                                    "https://gruporosinetos.com/entradaestoquemidias/"
                                                                );
                                                                window.open(link, "_blank", "noopener,noreferrer");
                                                            }}
                                                            style={{ cursor: 'pointer', display: 'flex', justifyContent: 'center', margin: 0, width: '50px', height: '50px' }}
                                                        >
                                                            {/* Verifica a extensão do arquivo e exibe a miniatura ou o ícone correspondente */}
                                                            {entradaEstoque.caminho_nf2.toLowerCase().endsWith('.pdf') ? (
                                                                <img alt={'miniatura_pdf'} style={{ textAlign: 'center' }} src={miniatura_pdf} />
                                                            ) : (
                                                                <img alt={'office'} style={{ textAlign: 'center' }} src={office} />
                                                            )}
                                                            <Typography align="center" variant="h7">
                                                                Nota Fiscal
                                                            </Typography>
                                                        </div>
                                                        <SwapHorizIcon {...getRootArquivoProps2()} />
                                                    </div>
                                                ) : (
                                                    <div {...getRootArquivoProps2()} style={dropzoneStyles(themeHelper)}>
                                                        <input {...getInputArquivoProps2()} />
                                                        <Typography align="center" variant="h7">
                                                            Anexo
                                                        </Typography>
                                                    </div>
                                                )}

                                            </Grid>
                                        </Grid>


                                        <Grid
                                            item xs={4}
                                            container
                                            direction="row"
                                            alignItems="flex-start" // 👈 importante
                                        >
                                            <Grid
                                                item xs={9}
                                                container
                                                direction="column"
                                                alignItems="center" // 👈 importante
                                            >
                                                <Grid container item xs={12} style={{ padding: 1 }}>
                                                    <TextField
                                                        variant="standard"
                                                        name="numeroNf3"
                                                        label="Número da NF"
                                                        required
                                                        id="numeroNf3"
                                                        value={numeroNf3}
                                                        onChange={(e) => setNumeroNf3(e.target.value)}
                                                        fullWidth
                                                        multiline
                                                        minRows={1}
                                                        InputProps={textFieldInputProps}
                                                        InputLabelProps={textFieldInputLabelProps}
                                                        sx={textFieldSxStandard}
                                                    />
                                                </Grid>
                                                <Grid container item xs={12} style={{ padding: 1 }}>
                                                    <TextField
                                                        variant="standard"
                                                        name="chaveNf3"
                                                        label="chaveNf3"
                                                        required
                                                        id="chaveNf3"
                                                        value={chaveNf3}
                                                        onChange={(e) => setChaveNf3(e.target.value)}
                                                        fullWidth
                                                        multiline
                                                        minRows={1}
                                                        InputProps={textFieldInputProps}
                                                        InputLabelProps={textFieldInputLabelProps}
                                                        sx={textFieldSxStandard}
                                                    />
                                                </Grid>
                                            </Grid>

                                            <Grid

                                                direction="row"
                                                justifyContent="center"
                                                align="cemter"
                                                item xs={1}
                                                container
                                                style={{ marginTop: 1 }}
                                            >

                                                {entradaEstoque.caminho_nf3 ? (
                                                    <div>
                                                        <div
                                                            onClick={() => {
                                                                const link = entradaEstoque.caminho_nf3.replaceAll(
                                                                    "/home/wwgrup/entradaestoque/",
                                                                    "https://gruporosinetos.com/entradaestoquemidias/"
                                                                );
                                                                window.open(link, "_blank", "noopener,noreferrer");
                                                            }}
                                                            style={{ cursor: 'pointer', display: 'flex', justifyContent: 'center', margin: 0, width: '50px', height: '50px' }}
                                                        >
                                                            {/* Verifica a extensão do arquivo e exibe a miniatura ou o ícone correspondente */}
                                                            {entradaEstoque.caminho_nf3.toLowerCase().endsWith('.pdf') ? (
                                                                <img alt={'miniatura_pdf'} style={{ textAlign: 'center' }} src={miniatura_pdf} />
                                                            ) : (
                                                                <img alt={'office'} style={{ textAlign: 'center' }} src={office} />
                                                            )}
                                                            <Typography align="center" variant="h7">
                                                                Nota Fiscal
                                                            </Typography>
                                                        </div>
                                                        <SwapHorizIcon {...getRootArquivoProps3()} />
                                                    </div>
                                                ) : (
                                                    <div {...getRootArquivoProps3()} style={dropzoneStyles(themeHelper)}>
                                                        <input {...getInputArquivoProps3()} />
                                                        <Typography align="center" variant="h7">
                                                            Anexo
                                                        </Typography>
                                                    </div>
                                                )}

                                            </Grid>
                                        </Grid>

                                        <Grid justifyContent="flex-end" direction="row" container item xs={12} style={{ padding: 2 }}>
                                            <Grid justifyContent="flex-end" direction="row" container item xs={1}  >
                                                <Button style={{ marginTop: 5 }}
                                                    variant="contained"
                                                    color="primary"
                                                    onClick={atualizar}
                                                > atualizar  </Button>
                                            </Grid>
                                        </Grid>


                                        <Divider />
                                        <Grid
                                            container
                                            direction="row"
                                            justifyContent="flex-end"
                                            alignItems="center"
                                            item xs={3}
                                        >
                                            {itensOriginais.length > 0 && itensOriginais.every(item => item.quantidade_estoque >= item.quantidade) ? (
                                                <Button style={{ marginTop: 5 }} variant="contained" color="secondary" disabled>
                                                    Todos os Itens em Estoque
                                                </Button>
                                            ) : (
                                                <Button
                                                    style={{ marginTop: 5 }}
                                                    variant="contained"
                                                    color="primary"
                                                    onClick={salvar}
                                                    disabled={botaoClicado}
                                                >
                                                    Salvar
                                                </Button>
                                            )}
                                        </Grid>
                                        <Grid
                                            style={{ paddingTop: 5 }}
                                            container
                                            direction="row"
                                            item xs={12}
                                            alignItems="center"
                                            justifyContent="center"
                                        >
                                            <div key={tabelaKey} style={{ width: '100%', overflowX: 'auto' }}>
                                                <div style={{ minWidth: '1200px' }}> {/* define uma largura mínima para forçar o scroll */}
                                                    <DataGrid
                                                        key={itens.length > 0 ? itens[0].id_item_ordem_compra : 'grid'}
                                                        pagination
                                                        checkboxSelection={false}
                                                        rows={itens}
                                                        getRowId={(row) => row.id_item_ordem_compra}
                                                        disableColumnResize={false}
                                                        onCellClick={handleCellClick2}
                                                        onRowClick={handleRowClick2}
                                                        components={{
                                                            Toolbar: CustomToolbar,
                                                        }}
                                                        columns={columnsDataGrid.map(column => ({
                                                            ...column,
                                                            disableColumnMenu: true,
                                                        }))}
                                                        sx={darkMode ? {
                                                            backgroundColor: '#1e1e1e',
                                                            color: 'white',
                                                            border: '1px solid #444',
                                                            '& .MuiDataGrid-main': {
                                                                color: 'white',
                                                            },
                                                            '& .MuiDataGrid-columnHeaders': {
                                                                backgroundColor: '#2d2d2d',
                                                                color: 'white',
                                                                borderBottom: '1px solid #555',
                                                            },
                                                            '& .MuiDataGrid-columnHeader': {
                                                                backgroundColor: '#2d2d2d',
                                                                color: 'white',
                                                            },
                                                            '& .MuiDataGrid-columnHeaderTitle': {
                                                                color: 'white',
                                                                fontWeight: 'bold',
                                                            },
                                                            '& .MuiDataGrid-cell': {
                                                                color: 'white',
                                                                borderBottom: '1px solid #393939',
                                                                backgroundColor: '#1e1e1e',
                                                            },
                                                            '& .MuiDataGrid-row': {
                                                                backgroundColor: '#1e1e1e',
                                                            },
                                                            '& .MuiDataGrid-row:hover': {
                                                                backgroundColor: 'rgba(255,255,255,0.06) !important',
                                                            },
                                                            '& .MuiDataGrid-footerContainer': {
                                                                backgroundColor: '#2d2d2d',
                                                                color: 'white',
                                                                borderTop: '1px solid #555',
                                                            },
                                                            '& .MuiTablePagination-root': {
                                                                color: 'white',
                                                            },
                                                            '& .MuiIconButton-root': {
                                                                color: 'white',
                                                            },
                                                            '& .MuiDataGrid-toolbarContainer': {
                                                                backgroundColor: '#2d2d2d',
                                                                color: 'white',
                                                            },
                                                            '& .MuiButton-root': {
                                                                color: 'white',
                                                            },
                                                            '& .MuiDataGrid-selectedRowCount': {
                                                                color: 'white',
                                                            },
                                                            '& .MuiDataGrid-sortIcon': {
                                                                color: 'white',
                                                            },
                                                            '& .MuiDataGrid-menuIconButton': {
                                                                color: 'white',
                                                            },
                                                            '& .MuiCheckbox-root': {
                                                                color: 'white',
                                                            },
                                                        } : {
                                                            '& .MuiDataGrid-columnHeader': {
                                                                backgroundColor: '#3f51b5',
                                                                color: 'white',
                                                            },
                                                        }}
                                                    />
                                                </div>
                                            </div>


                                        </Grid>

                                    </Grid>

                                    <Grid
                                        value={value} index={2}
                                        style={{ paddingTop: 20 }}
                                        container
                                        direction="row"
                                        item xs={12}
                                        alignItems="center"

                                        spacing={1}
                                    >


                                        <Grid
                                            container
                                            direction="row"
                                            alignItems="flex-start" // 👈 importante
                                            style={{ margin: 10 }}
                                            spacing={1}
                                        >
                                            <Grid item xs={3} style={{ padding: 2 }}>
                                                <TextField
                                                    variant="standard"
                                                    name="numeroNf"
                                                    label="Número da NF"
                                                    required
                                                    id="numeroNf"
                                                    value={numeroNf}
                                                    onChange={(e) => setNumeroNf(e.target.value)}
                                                    fullWidth
                                                    multiline
                                                    minRows={1}
                                                    InputProps={textFieldInputProps}
                                                    InputLabelProps={textFieldInputLabelProps}
                                                    sx={textFieldSxStandard}
                                                />
                                            </Grid>
                                            <Grid item xs={4} style={{ padding: 2 }}>
                                                <TextField
                                                    variant="standard"
                                                    name="chaveNf"
                                                    label="chaveNf"
                                                    required
                                                    id="chaveNf"
                                                    value={chaveNf}
                                                    onChange={(e) => setChaveNf(e.target.value)}
                                                    fullWidth
                                                    multiline
                                                    minRows={1}
                                                    InputProps={textFieldInputProps}
                                                    InputLabelProps={textFieldInputLabelProps}
                                                    sx={textFieldSxStandard}
                                                />
                                            </Grid>
                                            <Grid item xs={1} style={{ padding: 2 }}>
                                                <Button style={{ marginTop: 5 }}
                                                    variant="contained"
                                                    color="primary"
                                                    onClick={atualizar}
                                                > atualizar  </Button>
                                            </Grid>
                                            <Grid
                                                container
                                                direction="row"
                                                justifyContent="flex-end"
                                                align="flex-end"
                                                item xs={3}
                                                style={{ marginTop: 5 }}
                                            >

                                                {entradaEstoque.caminho_nf ? (
                                                    <div>
                                                        <div
                                                            onClick={() => {
                                                                const link = entradaEstoque.caminho_nf.replaceAll(
                                                                    "/home/wwgrup/entradaestoque/",
                                                                    "https://gruporosinetos.com/entradaestoquemidias/"
                                                                );
                                                                window.open(link, "_blank", "noopener,noreferrer");
                                                            }}
                                                            style={{ cursor: 'pointer', display: 'flex', justifyContent: 'center', margin: 0, width: '50px', height: '50px' }}
                                                        >
                                                            {/* Verifica a extensão do arquivo e exibe a miniatura ou o ícone correspondente */}
                                                            {entradaEstoque.caminho_nf.toLowerCase().endsWith('.pdf') ? (
                                                                <img alt={'miniatura_pdf'} style={{ textAlign: 'center' }} src={miniatura_pdf} />
                                                            ) : (
                                                                <img alt={'office'} style={{ textAlign: 'center' }} src={office} />
                                                            )}
                                                            <Typography align="center" variant="h7">
                                                                Nota Fiscal
                                                            </Typography>
                                                        </div>
                                                        <SwapHorizIcon {...getRootArquivoProps1()} />
                                                    </div>
                                                ) : (
                                                    <div {...getRootArquivoProps1()} style={dropzoneStyles(themeHelper)}>
                                                        <input {...getInputArquivoProps1()} />
                                                        <Typography align="center" variant="h7">
                                                            Anexo
                                                        </Typography>
                                                    </div>
                                                )}

                                            </Grid>
                                        </Grid>
                                        <Divider />
                                        <Grid
                                            container
                                            direction="row"
                                            alignItems="flex-start" // 👈 importante

                                            spacing={1}
                                        >

                                            {/* Box lateral (menu fake) */}
                                            <Box
                                                sx={{
                                                    width: 200,
                                                    backgroundColor: darkMode ? '#1e1e1e' : "#f9f9f9",
                                                    border: darkMode ? '1px solid #444' : "1px solid #ccc",
                                                    borderRadius: 2,
                                                    padding: 2,
                                                    boxShadow: 1,
                                                    marginRight: 2,
                                                    display: "flex",
                                                    flexDirection: "column",
                                                    color: darkMode ? '#fff' : 'inherit',
                                                }}
                                            >
                                                <Typography style={{ fontWeight: "bold", fontSize: 18, marginBottom: 1, marginLeft: 20, color: darkMode ? '#fff' : 'inherit' }}>
                                                    Itens da Compra
                                                </Typography>


                                            </Box>




                                        </Grid>
                                    </Grid>


                                </SwipeableViews>
                            </Grid>
                        </Grid>
                    </React.Fragment>
                }
            </Container >

            <Snackbar
                open={openAtualizando}
                autoHideDuration={1500}
                anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
            >
                <MuiAlert elevation={6} variant="filled"  >
                    Atualizando...
                </MuiAlert>
            </Snackbar>

        </div >
    );
}


